export default function MaintenanceNavService(gettext) {
  'ngInject';

  let module = {
    id: 'maintenance',
    name: gettext('Maintenance'),
    sref: 'maintenance',
    icon: 'fas fa-wrench',
    priority: 60,
    items: [
      {
        name: gettext('Maintenance'),
        sref: 'maintenance.board',
        group: 'dashboard'
      },
      {
        name: gettext('Maintenance History'),
        sref: 'maintenance.history',
        group: 'dashboard'
      },
      {
        name: gettext('Plans'),
        mobileName: gettext('View Plans'),
        sref: 'maintenance.plans',
        group: 'plans'
      },
      {
        name: gettext('Create New Plan'),
        sref: 'maintenance.createplan',
        group: 'plans'
      }
    ],
    groups: [
      {
        id: 'dashboard',
        name: gettext('Dashboard')
      },
      {
        id: 'plans',
        name: gettext('Plan Management')
      }
    ]
  };

  this.getModule = () => module;
}
